// import { Link, Outlet } from "react-router-dom"
// import { Outlet } from "react-router-dom"
import ImgOne from "../../assets/game_screenshots/SkyCityRush/SCR_gameplay_1.png";
import ImgTwo from "../../assets/game_screenshots/SkyCityRush/SCR_gameplay_2.png";
import ImgThree from "../../assets/game_screenshots/SkyCityRush/SCR_gameplay_3.png";
import ImgFour from "../../assets/game_screenshots/SkyCityRush/SCR_gameplay_4.png";
import ImgFive from "../../assets/game_screenshots/SkyCityRush/SCR_gameplay_5.png";

export const SkyCityRush = () => {
    return (
        <div className="sky-city-rush-page-container">
            <div className="page-content">
                <h1>Sky City Rush</h1>
                {/* <nav>
                    <Link to='privacy-policy'>Privacy Policy</Link>
                    <Link to='terms-of-service'>Terms of Service</Link>
                </nav> */}
                Welcome to the official support page for <b>'Sky City Rush'</b> — a neon-fueled futuristic racing game where speed, precision, and strategy collide in a high-octane arena. 
                Whether you're playing solo or against AI challengers, this page is here to help you enjoy the ride and stay informed.
                <div className="gameScreenshotContainer">
                    <img alt="Sky City Rush" src={ImgOne} className="gameScreenshotLandscape"/>
                </div>
                <h4>Game Information</h4>
                <br/>
                <b>About the Game</b><br/>'Sky City Rush' is a fast-paced arcade-style racing game set in a dazzling futuristic world. With sharp turns, nitro boosts, and dynamic AI opponents, every race is a test of reflexes and tactics. Master drifting, collect power-ups, and dominate the circuit.
                <br/>
                <div className="gameScreenshotContainer">
                    <img alt="Sky City Rush" src={ImgTwo} className="gameScreenshotLandscape"/>
                </div>
                <b>Features</b><br/>
                <u>Futuristic Visuals:</u> Race through neon-lit cityscapes and sci-fi inspired tracks.<br/>
                <u>Thrilling Mechanics:</u> Master tight corners, boost pads, and tactical resets.<br/>
                <u>Playable AI and Player Modes:</u> Challenge smart AI racers or control the car yourself.<br/>
                <u>Boost & Nitro:</u> Use well-timed nitro boosts to turn the tide mid-race.<br/>
                <u>Multiplatform:</u> Available on mobile and desktop builds.
                <div className="gameScreenshotContainer">
                    <img alt="Sky City Rush" src={ImgThree} className="gameScreenshotLandscape"/>
                </div>
                <b>Privacy Policy</b><br/>
                We take your privacy seriously. <b>'Sky City Rush'</b> is designed to provide a safe and secure gameplay experience:
                <ul>
                    <li>We do not collect any personal information or share any user data.</li>
                    <li>The app does not access device data without explicit permission.</li>
                    <li>If you have privacy-related questions, contact us at <a href="mailto:support@loen.in">support@loen.in</a>.</li>
                </ul>

                <div className="gameScreenshotContainer">
                    <img alt="Sky City Rush" src={ImgFour} className="gameScreenshotLandscape"/>
                </div>
                <h3>Contact Us</h3>
                For any feedback, issues, or support inquiries related to <b>'Sky City Rush'</b>, please email us at <a href="mailto:support@loen.in">support@loen.in</a>. We're committed to improving your experience.

                <p>Thanks for playing <b>'Sky City Rush'</b>. Race fast, race smart, and we hope you enjoy the journey to the finish line.</p>
                <div className="gameScreenshotContainer">
                    <img alt="Sky City Rush" src={ImgFive} className="gameScreenshotLandscape"/>
                </div>
                {/* Download 'Sky City Rush' from the <a href="https://apps.apple.com/in/app/sky-city-rush-mobile/id6469452088" target="_blank" rel="noreferrer">App Store</a> and Play Store. */}
                <br />
                <br />
                <br />
                🙂 Committed to follow the Play Families policy.
            </div>
        </div>
    )
}